import * as React from 'react';
// import { Table } from 'antd';
class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null, // 具体要显示的内容
      detail: false,
      tableLikelyData: [],
      tableUnlikelyData: [],
      str: null,
      heatmap: null,
    };
  }
  UNSAFE_componentWillMount() {
    console.log('this.props.data', this.props.data);
    if (this.props.data) {
      this.setState({ data: this.props.data }, () => {
        this.findTbleData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data }, () => {
        this.findTbleData();
      });
    }
  }

  // 查找table要显示的内容
  findTbleData = () => {
    let data = this.state.data;
    if (!data.content && data.content.length <= 0) {
      return;
    }
    let content = data.content;
    let ele = content.find(v => { return v.label === 'iws_ills'; });
    console.log('ele: ', ele);
    if (ele && ele.content && ele.content.length > 0) {
      let str = ele.content.find(v => { return v.label === 'illustration'; });
      if (str && str.content) {
        this.setState({ str: str.content });
      }
    }
    let heatmap = content.find(v => { return v.label === 'iws_heatmap_ele'; });
    console.log('heatmap: ', heatmap);
    if (heatmap && heatmap.content && heatmap.content.length > 0) {
      let str = heatmap.content.find(v => { return v.label === 'heatmap'; });
      if (str && str.content) {
        this.setState({ heatmap: str.content }, () => {
          console.log('heatmap: ', this.state.heatmap);
        });
      }
    }
    // this.setState({ heatmap: heatmap.content });
  }
  GetColorByPercent = (percent, value) => {
    const colors = ['#AB0000', '#FF0000', '#FDF200', '#72FF56', '#00FFCA', '#003AFF', '#000097'];
    let returnColor = '';
    if (value !== 0) {
      if (percent > 0 && percent <= 14) {
        returnColor = colors[3];
      }
      if (percent > 14 && percent <= 28) {
        returnColor = colors[4];
      }
      if (percent > 28 && percent <= 42) {
        returnColor = colors[5];
      }
      if (value > 0) {
        if (percent > 42 && percent <= 56) {
          returnColor = colors[3];
        }
      }
      if (value < 0) {
        if (percent > 42 && percent <= 56) {
          returnColor = colors[6];
        }
      }
      if (percent > 56 && percent <= 70) {
        returnColor = colors[2];
      }
      if (percent > 70 && percent <= 84) {
        returnColor = colors[1];
      }
      if (percent > 84 && percent <= 100) {
        returnColor = colors[0];
      }
    }
    if (value === 0) {
      returnColor = colors[3];
    }
    return returnColor;
  }
  render() {
    const getPoint = () => {
      let heatmap = this.state.heatmap;
      if (!heatmap || !heatmap.pointers | heatmap.pointers.length <= 0) {
        return null;
      }
      let returnList = [];
      let top = Math.abs(heatmap.top_value); // 取绝对值
      let bot = Math.abs(heatmap.bottom_value);
      let total = top + bot;
      for (let index = 0; index < heatmap.pointers.length; index++) {
        const element = heatmap.pointers[index];
        let pointVlaue = Math.abs(element.value); // 取绝对值
        if (element.value > 0) {
          pointVlaue = pointVlaue + bot;
        }
        let persent = Number((pointVlaue / total).toFixed(2));
        let color = this.GetColorByPercent(persent * 100, element.value);
        color = '20px solid ' + color;
        // 转化为css单位 rem 4rem为总高度
        if (element.value > 0) {
          persent = 4 - (4 * persent);
        }
        if (element.value < 0) {
          persent = 4 * (persent + 0.5);
        }
        if (element.value > 0) {
          returnList.push(
            <div style={{ height: '2rem' }} key={index}>
              <div className="img-t" style={{ marginTop: persent + 'rem' }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="img-tt" style={{ borderRight: color }}></div>
                  <div className="img-text">{element.label_disp}</div>
                </div>
              </div>
            </div >
          );
        }
        if (element.value < 0) {
          // persent = Math.abs(persent) + 2;
          returnList.push(
            <div style={{ height: '2rem' }} key={index}>
              <div className="img-b" style={{ marginTop: persent + 'rem' }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="img-bb" style={{ borderRight: color }}></div>
                  <div className="img-text">{element.label_disp}</div>
                </div>
              </div>
            </div >
          );
        }
        if (element.value === 0) {
          // persent = Math.abs(persent) + 2;
          returnList.push(
            <div style={{ height: '2rem' }} key={index}>
              <div className="img-b" style={{ marginTop: '2rem' }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="img-bb" style={{ borderRight: color }}></div>
                  <div className="img-text">{element.label_disp}</div>
                </div>
              </div>
            </div >
          );
        }
      }
      return returnList;
    };
    return (
      <React.Fragment>
        {
          this.state.data &&
          <React.Fragment>
            {
              !this.state.detail &&
              <div className="content">
                <div className="title">{this.state.data.label_disp}</div>
                <div className="cnt">
                  <React.Fragment>
                    {
                      this.state.heatmap &&
                      <div className="iws-bj">
                        <div className="bj-box">
                          <div className="text">{this.state.heatmap.top_label}</div>
                          {/* <div className="txt">bbbbbbbbbb</div> */}
                        </div>
                        <div className="iws-box">
                          <div className="box-numb">
                            <div className="numb-text">{this.state.heatmap.top_value}</div>
                            <div className="numb-text">{this.state.heatmap.middle_value}</div>
                            <div className="numb-text">{this.state.heatmap.bottom_value}</div>
                          </div>
                          <div className="box-t"></div>
                          <div className="box-img">
                            {getPoint()}

                            {/* <div style={{ height: '2rem' }}>
                              <div className="img-t" style={{ marginTop: '0rem' }}>
                                <div>
                                  <div className="img-tt" style={{ borderRight: '20px solid #be0707' }}></div>
                                </div>
                              </div>
                            </div> */}
                            {/* <div style={{ height: '2rem' }}>
                              <div className="img-b" style={{ marginTop: '2rem' }}>
                                <div>
                                  <div className="img-bb"></div>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <div className="bj-box">
                          <div className="text">{this.state.heatmap.bottom_label}</div>
                          {/* <div className="txt">bbbbbbbbbb</div> */}
                        </div>
                      </div>
                    }
                    <p>{this.state.str}</p>
                  </React.Fragment>
                </div>
              </div>
            }
          </React.Fragment>
        }
        {/* // <Iws data={this.state.data} /> */}

      </React.Fragment>
    );
  }
}

export default Summary;